module.exports = __webpack_public_path__ + "img/xk_banner.179603b6.png";